export const ErrorContent = {
  NO_ITEMS_SELECTED: 'Please select the items you would like to return.',
  NO_BOXES_SELECTED: 'Please select a number',
  BANNER_TEXT:
    'There was a temporary technical issue with your return request. Please try again shortly.',
  ERROR_ALL_ITEMS_INELIGIBLE_MESSAGE:
    "We're sorry. There's a complication with the return that requires the help of a Home Depot associate. Please call us at 1-800-430-3376 to discuss your return.",
  ERROR_GENERIC_MESSAGE:
    "We're sorry, but this order is not available to return online. You can make a return to your nearest Home Depot store. If you need assistance, please call us at 1-800-430-3376.",
  ERROR_GIFT_CARD_MESSAGE:
    "We're sorry, but we're not able to process online returns for purchases made with gift cards. You can make a return to your nearest Home Depot store in exchange for store credit. If you need assistance, please call customer support at 1-800-430-3376.",
  ERROR_MUTLI_VENDOR_MESSAGE:
    "We're sorry, but your order can't be packaged as a single return as the items require shipment to multiple vendors. You can return the order to your nearest Home Depot store. If you need assistance, please call us at 1-800-430-3376.",
  ERROR_BACK_END:
    'Please try again using the Return Item button below.  If this problem persists, please call Online Customer Care at 1-800-466-3337 to start your return.  You can also return items at your nearest Home Depot store.',
  ERROR_90_DAYS_PASSED:
    'We’re sorry, the return window has closed for this item and is no longer eligible for return. If you need assistance, please call customer support at 1-800-430-3376.',
  ERROR_PROTECTIONPLAN:
    'This return needs some special assistance from a Home Depot associate. Please call us at 1-800-430-3376 to start your return process.',
  ERROR_GENERIC_ERROR:
    "We're sorry, but this item is not available to return online. You can make a return to your nearest Home Depot store. If you need assistance, please call us at 1-800-430-3376.",
  ERROR_HAZMAT_MESSAGE:
    'Hazardous materials may not be returned by mail, but you can make a return to your nearest Home Depot store. If you need assistance, please call us at 1-800-430-3376',
  INVALID_VENDOR_ADDRESS_MESSAGE:
    'Sorry, we’re unable to process an online return for this purchase. Please return the items to your nearest Home Depot store. Alternatively, you can call Online Customer Care at 1-800-466-3337.',
};

export const RETURN_ERR_MESSAGE = {
  SSR_ORDAGGR_ERR_2010: ErrorContent.ERROR_90_DAYS_PASSED,
  SSR_ORDAGGR_ERR_2014: ErrorContent.ERROR_GENERIC_ERROR,
  SSR_ORDAGGR_ERR_2012: ErrorContent.ERROR_GENERIC_ERROR,
  SSR_ORDAGGR_ERR_2007: ErrorContent.ERROR_GENERIC_ERROR,
  SSR_ORDAGGR_ERR_2034: ErrorContent.ERROR_GENERIC_ERROR,
  SSR_ORDAGGR_ERR_2039: ErrorContent.ERROR_PROTECTIONPLAN,
  SSR_HRTVPOLICY_ERR_4012: ErrorContent.ERROR_HAZMAT_MESSAGE,
  SSR_HRTVPOLICY_ERR_4013: ErrorContent.ERROR_GENERIC_ERROR,
  SSR_HRTVPOLICY_ERR_4015: ErrorContent.INVALID_VENDOR_ADDRESS_MESSAGE,
};

export const RETURN_ERR_CODE = {
  WINDOW_ELAPSED_DAYS: 'SSR_ORDAGGR_ERR_2010',
  ERROR_PROTECTIONPLAN: 'SSR_ORDAGGR_ERR_2039',
  ERROR_HAZMAT: 'SSR_HRTVPOLICY_ERR_4012',
  INVALID_RETURN_ADDRESS: 'SSR_RETAGGR_ERR_5002',
};

export const returnsErrors = {
  GIFTCARD: `Unfortunately, we're not able to process an online return for purchases made with gift cards. For help with your return, plese call Online Customer Care at 1-800-466-3337. You can also return items at your nearest Home Depot store.`,
  MULTIVENDOR: `Unfortunately, your items can't be packaged as single return because they require shipment to multiple vendors. Please call us at 1-800-430-3376 and we'll help you with the return.`,
  GENERAL_ERROR: `This return needs some special assistance from a Home Depot associate. Please call us at 1-800-430-3376 to discuss your return.`,
  RETURNS_CREATE_P1: `Unforunately, a system error prevented your return request from
  being processed completely. You may still recieve an email from
  UPS about your shipping label -- please disregard this email,
  since the label won't be valid for your return.`,
  RETURNS_CREATE_P2: `To complete your return, please call us at 1-800-466-3337. A
  Home Depot associate will help you with the next steps.`,
  RETURNS_CREATE_P3: `We apologize for the inconvenience.`,
};

export const returnServiceTypes = {
  SSR_RESET: 'returnService/SSR_RESET',
  BACK_TO_LANDING: 'returnService/BACK_TO_LANDING',
  ELIGIBILITY_SUCCESS: 'returnService/ELIGIBILITY_SUCCESS',
  HRTV_SUCCESS: 'returnService/HRTV_SUCCESS',
  CHECKBOX_SELECT: 'returnService/CHECKBOX_SELECT',
  DROPDOWN_SELECT: 'returnService/DROPDOWN_SELECT',
  BOXES_SELECT: 'returnService/BOXES_SELECT',
  SET_ERRORS: 'returnService/SET_ERRORS',
  FETCH_REQUEST: 'returnService/FETCH_REQUEST',
  ON_LOAD_ERROR: 'returnService/ON_LOAD_ERROR',
  SSR_CREATE_SUCCESS: 'returnService/SSR_CREATE_SUCCESS',
  RETURNS_400_ERROR: 'returnService/RETURNS_400_ERROR',
  RETURNS_500_ERROR: 'returnService/RETURNS_500_ERROR',
  SSR_CREATE_ERROR: 'returnService/SSR_CREATE_ERROR',
  SSR_ERROR: 'returnService/SSR_ERROR',
  SET_LANDING_ERROR: 'returnService/SET_LANDING_ERROR',
  SET_SELECTED_BOXES_ERROR: '/returnService/SET_SELECTED_BOXES_ERROR',
};

export const returnLinks = {
  STORE_FINDER: 'http://www.homedepot.com/StoreFinder/index.jsp',
  POLICY_EXCEPTIONS: 'http://www.homedepot.com/c/Return_Policy',
};

export const reasonCodes = {
  'It is defective': '1',
  'It was damaged during shipping': '9',
  "I didn't order this item or item type": '13',
  "It doesn't match the photos/description": '13',
  'I no longer want or need it': '14',
  'I found a more competitive price': '14',
  'I ordered the wrong type, size, etc': '15',
  'It arrived later than expected': '21',
};
